export default "/50f517735fec46580f19aae3e56e9fe21614ea75/062e30a7ac6b62636e98a277a6442dbf.svg";